import React from "react";
import UserController from "../../services/system/user/user-controller";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {getSchoolYear} from "../../utils/authority";
import OfficerController from "../../services/system/staff/officer-controller";
class AutoSearchPeople extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowText: props.isShowText === undefined,
            principalName: props.principalName,
            principalUsername: props.principalUsername,
            principalId: props.principalId,
            listPeopleInSchool: [],
            pageNumber: 0,
            pageSize: 100,
            yearId: -1,
            page: 0,
            birthday: "",
            code: "",
            contract: '',
            degree: '',
            departmentId: -1,
            fullName: '',
            gender: '',
            job: '',
            jobState: '',
            onChange: false
        };
    }
    componentDidMount() {
        this.onhandleSearch()
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (this.state.principalId !==  nextProps.principalId){
            this.setState({
                principalName:  nextProps.principalName,
                principalId:  nextProps.principalId,
                principalUsername:  nextProps.principalUsername,
            })
        }
    }
    onhandleSearch(){
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            birthday: this.state.birthday,
            code: this.state.code,
            contract: this.state.contract,
            degree: this.state.degree,
            departmentId: parseInt(this.state.departmentId),
            fullName: this.state.fullName,
            gender: this.state.gender,
            job: this.state.job,
            jobState: this.state.jobState,
            "sort": "created_at desc"
        };
        OfficerController.search(payload, res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listPeopleInSchool: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: data.length < 0
                    }
                );
            } else {
            }
        });
    }
    render() {
        return (
            <Autocomplete
                size="small"
                options={this.state.listPeopleInSchool}
                getOptionLabel={option => option.fullName?option.fullName:"No Name"}
                style={{width: '100%'}}
                inputValue={this.state.principalName}
                renderInput={params => {
                    return <TextField
                        placeholder='Nhập tên'
                        {...params}
                        InputLabelProps={{
                            shrink: true,
                            style: {
                                fontSize: 17,
                                backgroundColor: "#FFF",
                                paddingRight: 10,
                                paddingLeft: 10,
                                color: '#2e495c',
                                fontWeight: 500,
                                fontFamily: 'Montserrat'
                            }
                        }}
                        label=""
                        variant="outlined"
                        fullWidth
                    />
                }}
                onInputChange={(event, val) => {
                    if (event !== null){
                        this.setState({
                            principalName: val
                        })
                        if (val === ""){
                            this.state.principalId = -1;
                            this.props.onUpdateData(this.state.principalId, this.state.principalUsername, this.state.principalName)
                        }
                    }
                }}
                onChange={(e, val) => {
                    if (val?.id != undefined){
                        this.state.principalId = val?.id;
                        this.state.principalUsername = val?.username;
                        this.state.principalName = val?.fullName;
                    }else {
                        this.state.principalUsername = "";
                        this.state.principalId = -1;
                    }
                    this.props.onUpdateData(this.state.principalId, this.state.principalUsername, this.state.principalName)
                    // this.getListPeopleInCharge()
                }}

            />
        );
    }
}
export default AutoSearchPeople;